import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { InsErrorBoundary } from "components/ux/insErrorBoundary";
import { language } from "language/default";
import { getConfig } from "plugins/config-loader";
import "./insWidgetErrorBoundary.scss";
/**
 * Fallback UI shown when a widget crashes
 * @param root0 - The component props
 * @param root0.error - The error that was caught
 * @param root0.resetErrorBoundary - Function to reset the error boundary
 * @param root0.widgetTitle - The title of the widget that crashed
 */
const WidgetErrorFallback = ({ error, resetErrorBoundary, widgetTitle }) => {
    const user = useSelector((s) => s.auth.oidc?.user?.profile.sub);
    const userIsDebugger = (getConfig("REACT_APP_DEBUGGERS") || "").split(",").includes(user);
    // Auto-reset for specific Highcharts height errors
    if (error.message?.includes("height") && error.stack?.includes("setExtremes")) {
        resetErrorBoundary();
    }
    const debuggerContent = userIsDebugger
        ? React.createElement("div", null,
            React.createElement("hr", null),
            error.name,
            ":",
            React.createElement("br", null),
            error.message)
        : null;
    return (React.createElement("div", { className: "errorMessage" },
        React.createElement("div", null,
            widgetTitle && React.createElement("strong", null,
                widgetTitle,
                ": "),
            language.en.widget.errorMessage,
            debuggerContent)));
};
/**
 * Error boundary specifically for dashboard widgets
 * Prevents a single widget crash from taking down the entire dashboard
 * @param root0 - The component props
 * @param root0.children - Child components to wrap
 * @param root0.widgetId - The ID of the widget
 * @param root0.widgetTitle - The title of the widget
 */
export const InsWidgetErrorBoundary = ({ children, widgetId, widgetTitle }) => {
    const fallbackComponent = useCallback((props) => React.createElement(WidgetErrorFallback, { ...props, widgetTitle: widgetTitle }), [widgetTitle]);
    return React.createElement(InsErrorBoundary, { fallback: fallbackComponent, 
        // Reset when widget ID changes
        resetKeys: [widgetId || ""] }, children);
};
